module.exports = [
  {'title': '北京', 'value': '402881882ba8753a012ba8bf474d001c'},
  {'title': '天津', 'value': '402881882ba8753a012ba8c389a2002f'},
  {'title': '河北省', 'value': '402881882ba8753a012ba8c689d30042'},
  {'title': '山西省', 'value': '402881882ba8753a012ba8c8f0b1004e'},
  {'title': '内蒙古自治区', 'value': '402881882ba8753a012ba8cb1bbf005a'},
  {'title': '辽宁省', 'value': '402881882ba8753a012ba8cd6a230067'},
  {'title': '吉林省', 'value': '402881882ba8753a012ba8d010f90076'},
  {'title': '黑龙江省', 'value': '402881882ba8753a012ba8d1b0310080'},
  {'title': '上海市', 'value': '402881882ba8753a012ba8d3f4f1008e'},
  {'title': '江苏省', 'value': '402881882ba8753a012ba8d780a800a2'},
  {'title': '浙江省', 'value': '402881882ba8753a012ba8da48e000b0'},
  {'title': '安徽省', 'value': '402881882ba8753a012ba8dc469500bc'},
  {'title': '福建省', 'value': '402881882ba8753a012ba8e0243500ce'},
  {'title': '江西省', 'value': '402881882ba8753a012ba8e362b600d8'},
  {'title': '山东省', 'value': '402881882ba8753a012ba8e5f7d800e4'},
  {'title': '河南省', 'value': '402881882ba8753a012ba92ba9c300f6'},
  {'title': '湖北省', 'value': '402881882ba8753a012ba92e37a20108'},
  {'title': '湖南省', 'value': '402881882ba8753a012ba930d6690115'},
  {'title': '广东省', 'value': '402881882ba8753a012ba9342b210124'},
  {'title': '广西壮族自治区', 'value': '402881882ba8753a012ba9376770013a'},
  {'title': '海南省', 'value': '402881882ba8753a012ba939ac010149'},
  {'title': '重庆市', 'value': '402881882ba8753a012ba93a6743014c'},
  {'title': '四川省', 'value': '402881882ba8753a012ba93d95780160'},
  {'title': '贵州省', 'value': '402881882ba8753a012ba940dad00173'},
  {'title': '云南省', 'value': '402881882ba8753a012ba942d1dd017a'},
  {'title': '西藏自治区', 'value': '402881882ba8753a012ba94474040183'},
  {'title': '陕西省', 'value': '402881882ba8753a012ba945a63a018b'},
  {'title': '甘肃省', 'value': '402881882ba8753a012ba94704c10196'},
  {'title': '青海省', 'value': '402881882ba8753a012ba949336801a4'},
  {'title': '宁夏回族自治区', 'value': '402881882ba8753a012ba94a847201ac'},
  {'title': '新疆维吾尔自治区', 'value': '402881882ba8753a012ba94b61c201b2'},
  {'title': '台湾省', 'value': '402881882ba8753a012ba94dc00501bd'},
  {'title': '香港特别行政区', 'value': '402881882ba8753a012ba94de66901be'},
  {'title': '澳门特别行政区', 'value': '402881882ba8753a012ba94e039601bf'}
]



// WEBPACK FOOTER //
// ./src/utils/province.js